export interface QueryMainReport {
  companyId: string;
  emission: string;
  unit?: string;
  flareCase: string;
  year: string;
  scope: EnumReportScope;
}

export interface QuerySummarizeMainReport {
  companyId?: string;
  emission?: string;
  unit?: string;
  flareCase?: string;
  year: string;
  scope?: EnumReportScope;
}

interface Summary {
  key: string;
  label: string;
  emission: string;
  unit: string;
  total: number | string;
  jan: number | string;
  feb: number | string;
  mar: number | string;
  apr: number | string;
  may: number | string;
  jun: number | string;
  jul: number | string;
  aug: number | string;
  sep: number | string;
  oct: number | string;
  nov: number | string;
  dec: number | string;
}

interface UnitData {
  summary: Summary;
}

export interface ResponseMainReportData {
  Kg: UnitData;
  Ton: UnitData;
  symbol: string;
  label: string;
}

export interface TmpResponseMainReportData {
  Kg: UnitData;
  Ton: UnitData;
}

export interface TmpMonthlyKey {
  jan: number | string;
  feb: number | string;
  mar: number | string;
  apr: number | string;
  may: number | string;
  jun: number | string;
  jul: number | string;
  aug: number | string;
  sep: number | string;
  oct: number | string;
  nov: number | string;
  dec: number | string;
}

export interface ResponseReportDataYearly {
  data: Record<string, { Kg: string | number; Ton: string | number }>;
  symbol: string;
  label: string;
}

export type FinalMainReportDataYearly = ResponseReportDataYearly[];

export enum EnumReportScope {
  YEARLY = "year",
  MONTHLY = "month",
}

export interface MainReportOverviews {
  vocsIntensityTarget2030: string;
  annualVocsTarget: string;
  vocsIntensity: string;
  vocsEmission: string;
}

export enum SymbolKeys {
  FUGITIVE = "fugitive",
  COMBUSTION = "combustion",
  FLARE = "flare",
  WASTE_WATER = "wasteWater",
  TANK = "tank",
  TERMINAL_MARKETING = "terminalMarketing",
  OTHERS = "others",
  ABSOLUTE = "absolute",
  INTENSITY_TARGET = "intensityTarget",
  INTENSITY = "intensity",
}

export interface ResponseSummarizeMainReport {
  companyName: string;
  value: number;
  unit: string;
  growthRate?: string;
  isGrowth: boolean;
}

export const MAP_LABEL_TO_CHARTS = {
  Fugitive: "Fugitive",
  Combustion: "Combustion",
  Flare: "Flare",
  "Transportation & Marketing": "Transport",
  "Storage Tank": "Tank",
  "Wastewater Treatment Plant": "WW",
  Others: "Others",
};

export type INVENTORY_CHARTS_KEYS = keyof typeof MAP_LABEL_TO_CHARTS;

export const MAP_SYMBOL_TO_DONUT_CHARTS = {
  fugitive: "Fugitive",
  combustion: "Combustion",
  flare: "Flare",
  terminalMarketing: "Transport",
  tank: "Tank",
  wasteWater: "WW",
  others: "Others",
};

export type INVENTORY_SYMBOL_KEYS = keyof typeof MAP_SYMBOL_TO_DONUT_CHARTS;
